import React, { useEffect } from 'react';
import './Donate.css';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Donate = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="donate-hero-section">
        <div className="donate-hero-content" data-aos="fade-up">
          <h1>Support Our Mission</h1>
          <p>Your generous donation empowers communities, provides education, and brings relief to those in need.</p>
        </div>
      </section>

      {/* Main Content */}
      <div className="donate-container">
        {/* Bank Details */}
        <section className="donate-card" data-aos="fade-up">
          <h2>Bank Details for Donation</h2>
          <p><strong>Bank Name:</strong> State Bank of India</p>
          <p><strong>Account Name:</strong> DEVELOPMENT EDUCATION & WELFARE TRUST</p>
          <p><strong>Account Number:</strong> 34748238737</p>
          <p><strong>IFSC Code:</strong> SBIN0001447</p>
        </section>

        {/* How to Donate */}
        <section className="donate-card" data-aos="fade-up" data-aos-delay="150">
          <h2>How to Donate</h2>
          <p>
            You can transfer funds directly to the above account via bank transfer. 
            Please include your name or organization name as the reference so that we can acknowledge your contribution.
          </p>
        </section>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default Donate;
